import { render, staticRenderFns } from "./QMyPendingPolicySubmenu.vue?vue&type=template&id=29d4df28&"
import script from "./QMyPendingPolicySubmenu.vue?vue&type=script&lang=js&"
export * from "./QMyPendingPolicySubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports